import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'merchantCoverPhoto',
})
export class MerchantCoverPhotoPipe implements PipeTransform {
  private readonly basePath: string;
  private readonly fallbackImage: string;

  constructor() {
    const rawBasePath = environment.basePath || 'http://localhost:9000/';
    this.basePath = rawBasePath.replace(/\/+$/, '') + '/';
    // Use your requested cover placeholder
    this.fallbackImage = 'assets/placeholderCoverPhoto.jpeg';
  }

  transform(photoUrl?: string | null, fallbackImage?: string): string {
    const fallback =
      fallbackImage && fallbackImage.trim()
        ? fallbackImage.trim()
        : this.fallbackImage;

    const value = (photoUrl ?? '').toString().trim();
    if (!value) return fallback;

    // Common invalid sentinel values
    if (
      value === 'null' ||
      value === 'undefined' ||
      value === 'NA' ||
      value === 'N/A'
    ) {
      return fallback;
    }

    // Already usable URLs
    if (/^(https?:)?\/\//i.test(value) || /^data:/i.test(value) || /^blob:/i.test(value)) {
      return value;
    }

    // App assets should pass through
    if (value.startsWith('assets/') || value.startsWith('/assets/')) {
      return value.startsWith('/') ? value.slice(1) : value;
    }

    // Normalize leading slashes
    const relative = value.replace(/^\/+/, '');

    // Handle upload paths like "/upload/..." or "upload/..."
    if (relative.startsWith('upload/')) {
      return `${this.basePath}${relative}`;
    }

    // Fallback: treat any other relative path as server-hosted
    return `${this.basePath}${relative}`;
  }
}


